module.exports = __webpack_public_path__ + "static/media/aterim.5b79db30.png";